
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/uxcore/[slug]",
      function () {
        return require("private-next-pages/uxcore/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/uxcore/[slug]"])
      });
    }
  